import { useQuery } from 'react-query';
import { baseApiUrl, fetcher, ServerErrorResponse } from '../../../../../../data_sources/constants';
import { Role } from 'views/App/Portal/LexID/Roles/_types/role';

export default function useOrganizationRole(
  organizationId?: string,
  id?: string,
  options = {},
  onError?: (errors: ServerErrorResponse) => void
) {
  const url = `${baseApiUrl()}/lexid/admin-role/v1/organizations/${organizationId}/roles`;
  return useQuery<Role, ServerErrorResponse>(
    ['organization_role', organizationId, id],
    async () => {
      try {
        if (!organizationId || !id) {
          return null;
        }
        const data = await fetcher({
          method: 'get',
          url: `${url}/${id}`,
        });
        return data;
      } catch (error: unknown) {
        if (onError && typeof error === 'object' && error !== null && 'errorDetails' in error) {
          onError(error as ServerErrorResponse);
        }
        throw error;
      }
    },
    {
      keepPreviousData: false,
      enabled: !!organizationId && !!id,
      ...options,
    }
  );
}
